// AipMark / AipWordmark — use the locked Attilius elephant brand asset.
// 2026-05-08: replaced fake square "A" SVG with the official elephant logo.
// Brand lock: Attilius=elephant. Never recreate the elephant in CSS.

export function AipMark({ className = "" }: { className?: string }) {
  return (
    <img
      src="/brand/attilius-elephant.png"
      alt="Attilius"
      className={className}
      style={{ display: "inline-block", height: "auto", verticalAlign: "middle" }}
    />
  );
}

export function AipWordmark({ className = "" }: { className?: string }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <AipMark className="w-7 h-7 text-foreground" />
      <div className="flex flex-col leading-none">
        <span className="text-[15px] font-semibold tracking-tight">Attilius</span>
        <span className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground mt-0.5">
          Mi6 Group · Attilius
        </span>
      </div>
    </div>
  );
}
